import {
  makeStyles,
  mergeClasses,
  Slider,
  tokens,
} from '@fluentui/react-components';
import React from 'react';

const styles = makeStyles({
  scrubber: {
    width: '100%',
    gridTemplateColumns: '1fr 100% 1fr',
    '[data-fui-focus-within] .scrubber-thumb': {
      visibility: 'visible',
    },
    '[data-fui-focus-within] .scrubber-rail': {
      height: '4px',
      borderTopWidth: '1px',
      borderRightWidth: '1px',
      borderBottomWidth: '1px',
      borderLeftWidth: '1px',
      borderTopStyle: 'solid',
      borderRightStyle: 'solid',
      borderBottomStyle: 'solid',
      borderLeftStyle: 'solid',
      borderTopColor: 'var(--Neutral-Background-Inverted-6-Rest, rgba(229, 229, 237, 1))',
      borderRightColor: 'var(--Neutral-Background-Inverted-6-Rest, rgba(229, 229, 237, 1))',
      borderBottomColor: 'var(--Neutral-Background-Inverted-6-Rest, rgba(229, 229, 237, 1))',
      borderLeftColor: 'var(--Neutral-Background-Inverted-6-Rest, rgba(229, 229, 237, 1))',
    },
    '&:hover .scrubber-thumb': {
      visibility: 'visible',
    },
    '&:hover .scrubber-rail': {
      height: '4px',
    },
  },
  scrubberThumb: {
    visibility: 'hidden',
    backgroundColor: tokens.colorNeutralBackground1,
    borderTopWidth: '0px',
    borderRightWidth: '0px',
    borderBottomWidth: '0px',
    borderLeftWidth: '0px',
    boxShadow: '0px 1.6px 10px 0px rgba(0, 0, 0, 0.3), 0px 0px 0.9px 0px rgba(0, 0, 0, 0.4)',
  },
  scrubberRail: {
    '&:focus-visible .scrubber-thumb': {
      visibility: 'visible',
    },
    borderTopLeftRadius: '0',
    borderTopRightRadius: '0',
    borderBottomLeftRadius: '0',
    borderBottomRightRadius: '0',
    '::before': {
      backgroundImage: 'none',
      '@media (forced-colors: active)': {
        backgroundImage: 'none',
      },
    },
  },
});

const DELTA_DIVISOR = 20; // 20 gives 5% delta

export const Scrubber = ({ usePlayerTime, usePlayerControls }) => {
  const classes = styles();
  const time = usePlayerTime();
  const { seek, duration, seekDelta } = usePlayerControls();
  const delta = duration / DELTA_DIVISOR;

  const handleKeyDown = (event) => {
    if (event.key === 'ArrowLeft') {
      seekDelta(-delta);
    } else if (event.key === 'ArrowRight') {
      seekDelta(delta);
    }
  };

  const handleOnChange = (_, data) => {
    seek(data.value);
  };

  return (
    <Slider
      value={time}
      max={duration}
      onChange={handleOnChange}
      min={0}
      thumb={{
              className: mergeClasses('scrubber-thumb', classes.scrubberThumb),
          }}
      rail={{
              className: mergeClasses('scrubber-rail', classes.scrubberRail),
          }}
      className={mergeClasses(classes.scrubber, 'clipchamp-player-scrubber')}
      aria-valuetext={`${time} seconds of ${duration} seconds`}
      size="small"
      onKeyDown={handleKeyDown}
    />
  );
};
